import { render, staticRenderFns } from "./boxsvg2.vue?vue&type=template&id=0fa2250d&scoped=true&"
var script = {}
import style0 from "./boxsvg2.vue?vue&type=style&index=0&id=0fa2250d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa2250d",
  null
  
)

export default component.exports